import { render, staticRenderFns } from "./Applyfor.vue?vue&type=template&id=1f5985aa&scoped=true&"
import script from "./Applyfor.vue?vue&type=script&lang=js&"
export * from "./Applyfor.vue?vue&type=script&lang=js&"
import style0 from "./Applyfor.vue?vue&type=style&index=0&id=1f5985aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5985aa",
  null
  
)

export default component.exports